/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Collapse, Row, Col, Tooltip, UncontrolledTooltip } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

// Moment
import moment from "moment";

// Custom methods
import {
  typeOf,
  isArray,
  isObject,
  objLength,
  convertSlaTime,
} from "../../../../../../Libs/CustomMethods/customMethods";

//Redux
import { useSelector } from "react-redux";

//Components
import MessageItem from "../../../PreviousConversations/subcomponents/MessageItem/MessageItem";

import ExtraInfo from "../ExtraInfo/ExtraInfo";

// Theme style
import "./lightTheme.scss";
import Survey from "../Survey/Survey";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const ClientInfoArea = ({ data, chatId, t, time }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  if (time < -1 && data?.conversationInformation?.status === 'active'){
    t(data.conversationInformation.status += " (Expired)")
  }
  
  const [collapse, setCollapse] = useState([]);
  const [collapseSubTransfer, setCollapseSubTransfer] = useState(false);
  const [collapseSubInsight, setCollapseSubInsight] = useState(false);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipObj, setTooltipObj] = useState(null);

  const block = ["departmentId", "consumerId", "sla", "userId", "skillId", "skill_id"];
  const regex =
    /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}[A-Z]{1}/;

  const toggle = (key) => {
    let aux = [...collapse];
    aux[key] = !aux[key];
    setCollapse(aux);
  };

  const toggleSubTransfer = (id) => {
    collapseSubTransfer !== id
      ? setCollapseSubTransfer(id)
      : setCollapseSubTransfer(null);
  };

  const toggleSubInsight = (id) => {
    collapseSubInsight !== id
      ? setCollapseSubInsight(id)
      : setCollapseSubInsight(null);
  };

  const favoriteMessages = (data) => {
    let msgs = data?.messages;

    let empty = (
      <div className="w-100 py-3 text-center">
        {t("No matching records found")}
      </div>
    );

    const handleDayTitle = (msgs, pos) => {
      let lastDate = msgs[pos - 1]
        ? moment(msgs[pos - 1].sentTime).format("DD/MM/YYYY")
        : null;
      let date =
        msgs[pos] && msgs[pos].sentTime
          ? moment(msgs[pos].sentTime).format("DD/MM/YYYY")
          : null;
      let today = moment().format("DD/MM/YYYY");
      let yesterday = moment().subtract(1, "days").format("DD/MM/YYYY");

      let title =
        date !== null && date !== lastDate ? (
          <li className="mt-4">
            <div className="chat-day-title">
              <span className="title px-3">
                {date === today ? "Hoje" : date === yesterday ? "Ontem" : date}
              </span>
            </div>
          </li>
        ) : (
          ""
        );
      return title;
    };

    const getSender = (chat, msg) => {
      let agent = data?.users
        ? data?.users?.find((e) => e?.user_id === msg?.userId)
        : [];
      agent = agent?.user_name;

      return msg?.systemMessage
        ? t("System message")
        : msg?.userId
        ? agent
          ? agent
          : t("Agent")
        : chat?.consumer?.name;
    };

    if (isArray(msgs)) {
      return (
        <>
          <ul className="list-unstyled mt-3">
            {msgs?.length > 0
              ? msgs.map((msg, key) => (
                  <div key={key} className={`d-flex flex-column`}>
                    {handleDayTitle(msgs, key)}
                    <MessageItem
                      isRight={msg?.userId || msg?.systemMessage ? "right" : ""}
                      name={getSender(data, msg)}
                      message={msg?.text ?? msg?.message}
                      msg={{
                        ...msg,
                        chatId: chatId,
                        favorite: true,
                      }}
                      file={msg?.files}
                      time={msg?.sentTime}
                    />
                  </div>
                ))
              : empty}
          </ul>
        </>
      );
    } else {
      return empty;
    }
  };

  const insightsMatches = (data) => {
    let entriesArray = isObject(data) && Object.entries(data);
    return entriesArray.map((item, key1) => {
      const insightName = item[0];
      const insightValues = item[1];
      return (
        <div
          key={key1}
          className={`item subitem ${
            collapseSubInsight === key1 && "item-opened-child"
          }`}
        >
          <div
            className="text-wrap pointer d-flex py-3"
            onClick={() => {
              toggleSubInsight(key1);
            }}
          >
            <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon-child"></i>
            <div className="d-flex flex-column w-100 ml-2 pl-1">
              <div className="d-flex justify-content-between my-auto">
                <div className="d-inline-flex order-1 title font-weight-bold">
                  {t(insightName)}
                </div>
              </div>
            </div>
          </div>
          <Collapse
            isOpen={collapseSubInsight === key1}
            className="px-3 mx-1 my-0 border"
          >
            {isArray(insightValues) &&
              insightValues.map((value, key2) => (
                <div
                  key={key2}
                  id={`insight-${key1}-${key2}`}
                  className="d-flex justify-content-between border dataItem insight my-2 px-2"
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    setTooltipObj({
                      target: `insight-${key1}-${key2}`,
                      message: `${value} ${t("Copied to keyboard!")}`,
                    });
                  }}
                >
                  <div sm="12" className="font-weight-bold overflow-auto">
                    {value}
                  </div>
                  <i
                    id={`insight-tip-${key2}`}
                    className="mdi mdi-content-copy"
                  />
                  <UncontrolledTooltip
                    placement="auto"
                    target={`insight-tip-${key2}`}
                  >
                    {t("Click to copy")}
                  </UncontrolledTooltip>
                  {tooltipOpen && tooltipObj && (
                    <Tooltip
                      placement="auto"
                      isOpen={tooltipOpen}
                      target={tooltipObj?.target}
                    >
                      <div className="keywords-tooltip">
                        {tooltipObj?.message}
                      </div>
                    </Tooltip>
                  )}
                </div>
              ))}
          </Collapse>
        </div>
      );
    });
  };

  const showMessages = (objEntries) => {
    let entriesValues = isArray(objEntries) && objEntries[1];

    if (
      entriesValues?.closedById &&
      entriesValues?.closedByUser &&
      entriesValues?.closedByRole
    ) {
      let closedBy = `${entriesValues?.closedByRole}(${entriesValues?.closedByUser})`;

      entriesValues = { closedBy: closedBy, ...entriesValues };

      delete entriesValues.closedById;
      delete entriesValues.closedByUser;
      delete entriesValues.closedByRole;
    } else if (entriesValues?.closedByRole) {
      entriesValues = {
        closedBy: entriesValues?.closedByRole,
        ...entriesValues,
      };
      delete entriesValues.closedByRole;
    }

    let empty = (
      <div className="w-100 py-3 text-center">
        {t("No matching records found")}
      </div>
    );

    const showSubMenu = (item) => {
      if (item[0]) {
        switch (item[0]) {
          case "extra":
          case "extraInfo":
            return <ExtraInfo title={item[0]} obj={item[1]} />;
          case "preChat":
          case "posChat":
            return <Survey title={item[0]} obj={item[1]} />;
          default:
            return (
              <div
                key={item[0]}
                className={`item subitem ${
                  collapseSubTransfer === item[0] && "item-opened-child"
                }`}
              >
                <div
                  className="text-wrap pointer d-flex py-3"
                  onClick={() => {
                    toggleSubTransfer(item[0]);
                  }}
                >
                  <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon-child"></i>
                  <div className="d-flex flex-column w-100 ml-2 pl-1">
                    <div className="d-flex justify-content-between my-auto">
                      <div className="d-inline-flex order-1 title font-weight-bold">
                        {t(item[0])}
                      </div>
                    </div>
                  </div>
                </div>
                <Collapse
                  isOpen={collapseSubTransfer === item[0]}
                  className="px-3 mx-1 my-0 border"
                >
                  {isArray(item[1]) && item[1].length > 0
                    ? item[1].map((e, key) => {
                        let data = [];

                        data.push(
                          <Row
                            key={key}
                            className="my-2 dataItem border-bottom"
                          >
                            <Col sm="12" className="font-weight-bold">
                              <i
                                className={`mdi mdi-${
                                  e?.type === "assignment" ? "pin" : "share"
                                } font-size-15 mr-1`}
                              />
                              {`${e.type ? t(e.type) : t("transfer")}`}:
                            </Col>
                          </Row>
                        );

                        isObject(e) &&
                          data.push(
                            Object.entries(e).map(
                              (item, key) =>
                                item[0] !== "type" &&
                                item[1] &&
                                !block.find((e) => e === item[0]) && (
                                  <div key={key}>
                                    <Row className="dataItem justify-content-between">
                                      <Col
                                        sm="5"
                                        className="font-weight-bold pr-0 text-nowrap"
                                      >
                                        {t(item[0])}:
                                      </Col>
                                      <Col sm="5" className="escapeDragScroll">
                                        {typeOf(item[1], "string") &&
                                        regex.test(item[1])
                                          ? moment(item[1]).format(
                                              "DD/MM/yyyy HH:mm:ss"
                                            )
                                          : t(item[1])}
                                      </Col>
                                    </Row>
                                  </div>
                                )
                            )
                          );

                        data.push(
                          <Row
                            key={key}
                            className="my-2 dataItem border-bottom"
                          />
                        );
                        return data;
                      })
                    : empty}
                </Collapse>
              </div>
            );
        }
      }
    };

    if (entriesValues && objLength(entriesValues) > 0) {
      switch (objEntries[0]) {
        case "favoriteMessagesInformation":
          return favoriteMessages(entriesValues);
        case "conversationInsights":
          return insightsMatches(entriesValues);
        default:
          return Object.entries(entriesValues).map((item, key) => {
            if (item[1]) {
              switch (item[0]) {
                case "transferHistory":
                case "extraInfo":
                case "extra":
                case "preChat":
                case "posChat":
                  return showSubMenu(item);
                default:
                  return (
                    !block.find((e) => e === item[0]) && (
                      <div key={key}>
                        <Row className="mx-2 dataItem justify-content-between">
                          <Col
                            sm="5"
                            className="font-weight-bold pr-0 text-nowrap"
                          >
                           {t(item[0])}:
                          </Col>
                          <Col sm="5" className="escapeDragScroll">
                            {typeof item[1] === "string" &&
                              (regex.test(item[1])
                                ? moment(item[1]).format("DD/MM/yyyy HH:mm:ss")
                                : t(item[1]))}

                            {item[0] === "csat" && (
                              <i className="fas fa-star csat"></i>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )
                  );
              }
            } else {
              return null;
            }
          });
      }
    } else {
      return empty;
    }
  };

  const showTabs = () => {
    return objLength(data) > 0
      ? Object.entries(data).map((e, key) => (
          <div
            key={key}
            className={`item ${collapse[key] && "item-opened"}
                border-bottom`}
          >
            <div
              className="text-wrap pointer d-flex py-3"
              onClick={() => {
                toggle(key);
              }}
            >
              <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
              <div className="d-flex flex-column w-100 ml-2 pl-1">
                <div className="d-flex justify-content-between my-auto">
                  <div className="d-inline-flex order-1 title">{t(e[0])}</div>
                </div>
              </div>
            </div>
            <Collapse
              isOpen={collapse[key]}
              className={`px-3 ${
                e[0] === "favoriteMessagesInformation"
                  ? `favoriteMessages ${mainTheme === "dark" ? "dark" : "light"} mx-3`
                  : "mx-1"
              }`}
            >
              {showMessages(e)}
            </Collapse>
          </div>
        ))
      : showMessages(null);
  };

  useEffect(() => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
  }, [tooltipObj]);

  useEffect(() => {
    if (!data) return;

    const consumerInfo = data["consumerInformation"];
    if (consumerInfo) {
      const consumerInfoFormated = Object.keys(consumerInfo)?.map((key) => {
        if (key === "id") {
          return { "User id": consumerInfo[key] };
        } else {
          return { [key]: consumerInfo[key] };
        }
      });

      data["consumerInformation"] = consumerInfoFormated?.reduce((a, b) =>
        Object.assign({}, a, b)
      );
    }

    const conversationInfo = data["conversationInformation"];
    if (conversationInfo) {
      const conversationInfoFormated = Object.keys(conversationInfo)?.map(
        (key) => {
          switch (key) {
            case "id":
              return { "Conversation id": conversationInfo[key] };
            case "sla":
              const time = convertSlaTime(Number(conversationInfo[key]));
              return { [key]: conversationInfo[key],   "SLA": time };
            case "skill_id":
              return {};
            default:
              return { [key]: conversationInfo[key] };
          }
        }
      );
      data["conversationInformation"] = conversationInfoFormated?.reduce(
        (a, b) => Object.assign({}, a, b)
      );
    }
  }, [data]);

  useEffect(() => {
    if (chatId && data && collapse.length === 0) {
      collapse.fill.call({ length: objLength(data) }, false);
    }
  }, [chatId, data]);

  useEffect(() => {
    mainTheme && importDarkMode(mainTheme);
  }, [mainTheme]);

  return <>{chatId ? showTabs() : ""}</>;
};
export default withTranslation()(React.memo(ClientInfoArea));
